import React from 'react'
import { Dashboard } from './views/Dashboard'
import { Products } from './views/Products'
import { Requests } from './views/Requests'
import { FiBarChart, FiClipboard, FiHome, FiPackage, FiSettings } from 'react-icons/fi'
import { useModuleView } from '../hooks/useModuleView'
import { Reports } from './views/Reports'
import { Catalogs } from './views/Catalogs'
import { PDFViewer } from '@react-pdf/renderer'
import { OrderPurcharse } from './requests/documents/OrderPurcharse'

export const Layout = () => {
  /**
   * ToDo:
   *  - Realizar el Router por states
   *  - Mostrar dinamicamente los componentes.
   *  - Ver si posible asignar acceso controlado por perfil de usuario
  */

  const viewsMap = {
    dashboard: Dashboard,
    products: Products,
    requests: Requests,
    reports: Reports,
    catalogs: Catalogs,
  };

  const { view, setView, renderView, isView } = useModuleView('dashboard', viewsMap);
  const btnClass = (key) => isView(key) ? 'btn btn-dark me-2 mb-2' : 'btn btn-outline-dark me-2 mb-2';

  return (
    <div className=''>
      <div className=''>
        <div className='d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center border-bottom'>
          <h1 className="h3 fw-bold">Inventario </h1>

          <div className="btn-group mb-3 flex-wrap" role="group">
            <button className={btnClass('dashboard')} onClick={() => setView('dashboard')}>
              <FiHome size={20} className='me-1' /> Dashboard
            </button>
            <button className={btnClass('products')} onClick={() => setView('products')}>
              <FiPackage size={20} className='me-1' /> Productos
            </button>
            <button className={btnClass('requests')} onClick={() => setView('requests')}>
              <FiClipboard size={20} className='me-1' /> Ordenes de compra
            </button>
            {/* <button className={btnClass('reports')} onClick={() => setView('reports')}>
              <FiBarChart size={20} className='me-1' /> Reportes
            </button> */}
            <button className={btnClass('catalogs')} onClick={() => setView('catalogs')}>
              <FiSettings size={20} className='me-1' /> Catálogos
            </button>
          </div>
        </div>
    
        <div className="mt-3">
          {renderView()}
        </div>
      </div>
    </div>
  )
}
